// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sDndA","right":"Footer_right__pY45r","buttons":"Footer_buttons__1KvNR"};